import React from "react";
import { STATUS } from "@/lib/status";

export function StatusBadge({ status, className = "" }) {
  const s = STATUS[status] || STATUS.none;
  const { Icon } = s;
  return (
    <span
      data-testid={`status-badge-${s.key}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold border ${s.badge} ${className}`}
    >
      <Icon className="w-3.5 h-3.5" />
      {s.label}
    </span>
  );
}
